
import React, { Component } from 'react';
import StripePaymentContainer from "./stripePayment/stripePaymentContainer";

class PaymentComponent extends Component 
{
    constructor(props)
    {
        super(props);
    }

    render()
    {
        return <StripePaymentContainer amount={this.props.amount} onCompletion={this.props.onCompletion} onDismiss={this.props.onDismiss}/>
    }
}

export default PaymentComponent;